<template>
  <section>
    <ul class="templates-menu" v-if="hasTemplates && !secure">
      <li v-for="(value, id) in templates" :key="id">
        <div class="button-container">
          <button class="option-button" @click="setTemplate(value)">
            {{ value.name }}
          </button>
        </div>
        <remove-button
          class="remove-file"
          @remove="deleteTemplate(id)"
        ></remove-button>
      </li>
    </ul>
    <ul class="product-menu">
      <li v-for="product in products" :key="product" class="dual-button-remove">
        <button
          class="option-button"
          :class="{ active: activeProduct === product }"
          @click="$emit('setProduct', product)"
        >
          {{ product }}
        </button>
        <button class="remove-btn-white" @click="$emit('clear')">
          <span></span>
        </button>
      </li>
    </ul>
  </section>
</template>

<script>
import isEmpty from 'lodash-es/isEmpty'
import RemoveButton from '@/components/ui/RemoveButton'
import { deletePrintTemplate } from '../../PrintOrderApi'
import { useFileListStore } from '@/stores/FileList.store'
import { mapStores } from 'pinia'

export default {
  props: ['products', 'files', 'templates', 'secure'],
  components: { RemoveButton },
  methods: {
    setTemplate(value) {
      this.fileListStore.addProduct(this.fileNames, value.productSpecs)
      this.fileListStore.updateFileSpec(this.fileNames, 'template', value.name)
      this.fileListStore.updateFileSpec(
        this.fileNames,
        'colorMode',
        value.colorMode
      )
      this.fileListStore.updateFileSpec(this.fileNames, 'format', value.format)
      this.fileListStore.updateFileSpec(
        this.fileNames,
        'material',
        value.material
      )
      this.fileListStore.updateFileSpec(this.fileNames, 'side', value.side)
      this.fileListStore.updateFileSpec(
        this.fileNames,
        'treatment',
        value.treatment
      )
    },
    deleteTemplate(id) {
      deletePrintTemplate(id).then((resp) => {
        this.$emit('reset', resp)
      })
    }
  },
  computed: {
    ...mapStores(useFileListStore),
    activeProduct() {
      let products = []
      this.files.forEach((file) => {
        if (
          file.productSpecs.title &&
          products.indexOf(file.productSpecs.title) < 0
        ) {
          products.push(file.productSpecs.title)
        }
      })

      return products.length === 1 ? products[0] : ''
    },
    hasTemplates() {
      return !isEmpty(this.templates)
    },
    fileNames() {
      let fileNames = []
      this.files.forEach((file) => {
        fileNames.push(file.fileName)
      })
      return fileNames
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  line-height: 34px;
  margin-left: -8px;
}

.templates-menu {
  .remove-file {
    flex-shrink: 0;
  }

  border-bottom: 1px solid #efefef;

  li {
    display: flex;

    align-items: center;

    .button-container {
      flex-grow: 1;
      overflow: hidden;

      button {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
      }
    }
  }
}

.dual-button-remove {
  position: relative;

  button:first-child {
    padding-right: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  button:nth-child(2) {
    position: absolute;
    margin-left: -15px;
    top: 13px;
  }
}
</style>
